import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[map-split-panel-host]',
})
export class MapSplitPanelHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
